import {Button} from '@wandb/components';
import {IconLightbulbInfo} from '@wandb/weave/components/Icon';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import * as React from 'react';

import {useStablePanelId} from '../Panel/PanelIDContext';
import {recordRumAction} from './../../util/datadog/datadogRum';
import {usePanelSystemMetricsContext} from './SystemMetrics/PanelSystemMetricsContext';

export const DelayRender = ({title}: {title: string}) => {
  const stablePanelId = useStablePanelId();
  const {setAllowUncappedMetrics} = usePanelSystemMetricsContext();

  React.useEffect(() => {
    recordRumAction('system_metrics_capped_panel_mounted', {
      title,
      panelId: stablePanelId,
    });
  }, [title, stablePanelId]);

  return (
    <TailwindContents>
      <div className="flex h-full flex-col overflow-hidden [grid-area:delay-render]">
        <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden">
          <div className="flex min-h-full min-w-0 flex-col items-center justify-center gap-8 p-8 pb-0 text-center">
            <div className="flex h-48 w-48 shrink-0 items-center justify-center rounded-full bg-blue-200">
              <IconLightbulbInfo className="text-blue-600" height={24} />
            </div>
            <div className="w-full break-words py-8 text-sm">
              This panel includes a large number of metrics and runs, which may
              affect workspace performance.
            </div>
          </div>
        </div>
        <div className="flex shrink-0 justify-center p-8">
          <Button
            variant="secondary"
            size="sm"
            onClick={() => {
              recordRumAction('system_metrics_capped_panel_displayed', {
                title,
                panelId: stablePanelId,
              });
              setAllowUncappedMetrics(true);
            }}>
            Load anyway
          </Button>
        </div>
      </div>
    </TailwindContents>
  );
};
